import { render, staticRenderFns } from "./branchList.vue?vue&type=template&id=26282cd6&scoped=true"
import script from "./branchList.vue?vue&type=script&lang=js"
export * from "./branchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26282cd6",
  null
  
)

export default component.exports